import { render } from "./HeroImageComponent.vue?vue&type=template&id=32650b02&scoped=true&ts=true"
import script from "./HeroImageComponent.vue?vue&type=script&lang=ts"
export * from "./HeroImageComponent.vue?vue&type=script&lang=ts"

import "./HeroImageComponent.vue?vue&type=style&index=0&id=32650b02&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32650b02"]])

export default __exports__